/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import Accordion from '../../Components/AccordionLight';
import NavBarVertical from '../../Components/NavBarVertical';
import NavBarMobile from '../../Components/NavBarMobile';

class Profile02 extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta key="og:title" property="og:title" content="EDvice" />
          <meta key="description" name="description" content="EDvice" />
          <meta key="og:description" property="og:description" content="EDvice" />
        </Head>
        <Navbar>Navbar</Navbar>

        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./linguaskill_desktop.png')}
            column="col-xs-5"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Information about the Linguaskill test</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobile />
              <NavBarVertical />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="content-inner">
                <div className="profile-format-content">
                  <img alt="Research" src={require('./science01.jpg')} />
                  <div>
                    <h1>Dr Ardeshir Geranpayeh</h1>
                    <p>Head of Automated Assessment and Learning</p>
                  </div>
                </div>
                <p>
                  Dr Ardeshir Geranpayeh is Head of Automated Assessment and Learning at Cambridge
                  English, which he joined in 2001. Since 2009, he has been leading on the
                  development and implementation of the automated assessment of writing and
                  speaking. He has 29 years’ experience of test validation and has contributed to
                  the design, development, validation, revision and evaluation of almost all
                  Cambridge English language proficiency tests. Additionally, he is a regular
                  presenter at international conferences where he has led workshops on statistics,
                  computer-based testing, listening tests and test security. He holds a PhD in
                  Applied Linguistics from the University of Edinburgh on the comparability of
                  language proficiency testing.
                </p>
                <div className="profile__section">
                  <Accordion>
                    <div label="When did you become involved in Linguaskill?">
                      <h3>When did you become involved in Linguaskill?</h3>
                      <p>
                        I was involved at the initial conceptual design stage, dating back to 2002.
                        More recently Linguaskill was re-invented, putting automatic assessment at
                        the heart of the product.
                      </p>
                    </div>
                    <div label="Describe your role and involvement in Linguaskill.">
                      <h3>Describe your role and involvement in Linguaskill.</h3>
                      <p>
                        I was involved at the design stage for the technical model, creating the
                        Computer Adaptive Test (CAT) for Reading and Listening. I was also
                        responsible for preparing the automated assessment engine for marking
                        Linguaskill’s Writing and Speaking components.
                      </p>
                    </div>
                    <div label="What were the needs you were looking to solve with Linguaskill?">
                      <h3>What were the needs you were looking to solve with Linguaskill?</h3>
                      <p>
                        A valid, reliable, quick and cost-effective test of proficiency that could
                        be delivered online to candidates with immediate reporting of results, all
                        at an affordable price.
                      </p>
                    </div>
                    <div label="In your opinion, what makes Linguaskill different from other tests?">
                      <h3>In your opinion, what makes Linguaskill different from other tests?</h3>
                      <p>
                        There are two main features. Firstly, its adaptiveness, which means that
                        each candidate receives a different set of test items, personalised to their
                        true ability level. Secondly, using AI technology to deliver immediate
                        marking of the Writing and Speaking tests.
                      </p>
                    </div>
                    <div label="What have you learned while developing Linguaskill?">
                      <h3>What have you learned while developing Linguaskill?</h3>
                      <p>
                        It is important to keep the customer at the heart of planning any new test.
                        We learned how to use sophisticated technology to improve candidates’
                        experience of taking the test, while ensuring that results are reported to
                        stakeholders in a fast and efficient way. Everyone in the team has been
                        working towards that goal of meeting customer needs and making the product
                        simple to use.
                      </p>
                    </div>
                    <div label="Now that Linguaskill is in the market, what are you most satisfied with in terms of the product and market adoption?">
                      <h3>
                        Now that Linguaskill is in the market, what are you most satisfied with in
                        terms of the product and market adoption?
                      </h3>
                      <p>
                        The ease with which candidates can sit the test, and the simplicity to run
                        the test locally are the most satisfying features we managed to achieve in
                        Linguaskill. We’ve had lots of positive feedback around these areas, which
                        is extremely rewarding for us.
                      </p>
                    </div>
                    <div label="How do you see Linguaskill developing over the next 2–3 years?">
                      <h3>How do you see Linguaskill developing over the next 2–3 years?</h3>
                      <p>
                        The Linguaskill family tests will grow rapidly in terms of its use by
                        multiple stakeholders and will become, I hope, the default benchmarking
                        proficiency test of choice for various test purposes.
                      </p>
                    </div>
                    <div label="What are you working on now?">
                      <h3>What are you working on now?</h3>
                      <p>
                        I’m continuing to work on the improvement of the automarker for writing and
                        speaking, introducing new diagnostic features to provide efficient feedback
                        to candidates to improve their English.
                      </p>
                    </div>
                    <div label="How do you see computer-based testing changing in the future, with the increasing use of AI?">
                      <h3>
                        How do you see computer-based testing changing in the future, with the
                        increasing use of AI?
                      </h3>
                      <p>
                        I believe AI will become part and parcel of any computer-based test in the
                        future. We are happy that we are leading in this area.
                      </p>
                    </div>
                    <div label="Are there other key trends that you see impacting language learning and testing over the next five years?">
                      <h3>
                        Are there other key trends that you see impacting language learning and
                        testing over the next five years?
                      </h3>
                      <p>
                        It is very clear that AI will have a big impact on language learning and
                        testing moving forward. The Cambridge Learning Oriented Assessment (LOA)
                        approach, which has AI at its heart, will significantly change language
                        learning and testing by bringing these two areas closer, helping drive more
                        effective, individual learning.
                      </p>
                    </div>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </React.Fragment>
    );
  }
}
export default Profile02;
